<template lang="pug">
form.v-field-search.field-search(v-if="field" :class="[field.theme ? 'field-search--' + field.theme : '']" @submit.prevent="relocate" @reset.prevent="handlerClose")
	v-svg-icon.field-search__icon(:icon="icon")
	.field-search__input-area
		input.field-search__input(type="text" v-model="localValue" @input="handleInput" @focus="handleFocus" :placeholder="field.placeholder")
	button.field-search__clear(v-if="localValue" type="button" @click="localValue = null")
		v-svg-icon.field-search__clear-icon(icon="cross-sm")
	button.field-search__btn.btn.btn--primary(type="button" @click="relocate") {{field.actionText}}

</template>

<script>

import controller from "../scripts/controller/controller";

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [String, Number],
			default: null
		},

		mode: {
			type: String,
			default: null
		},

		icon: {
			type: String,
			default: "graphic-search"
		}
	},

	emits: [
		'update:model-value',
		'close'
	],

	data() {
		return {
			localValue: null
		};
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.localValue = this.modelValue;
			}
		}
	},

	methods: {

		relocate() {
			if (this.field.remote && this.localValue) {
				let searchUrl = new URL(window.location.protocol + window.location.host + this.field.remote);
				searchUrl.searchParams.append('query', this.localValue);
				window.location = searchUrl;
			}
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue, this.field);
		},

		handleFocus() {
			if (this.mode === 'modal') {
				controller.events.emit('openSearch');
			}
		},

		handlerClose() {
			this.$emit('close');
		}
	}
};
</script>
